module.exports = __webpack_public_path__ + "img/banner2.484053ec.png";